

export const withProvider = (Provider, Component) => {

    return (props)=>(
        <Provider>
            <Component {...props}/>
        </Provider>
    )
}